import type { AdapterStatuses, AppState, Preferences } from '../domain/models'
import { defaultShowId, seedContentItems, seedFeedPosts, seedNotifications, tourShows } from '../fixtures'

export const defaultPreferences: Preferences = {
  reducedMotion: false,
  highContrast: false,
  showReminders: true,
  communityReplies: true,
  savedShowsOnly: false,
  defaultChannel: 'main',
}

export const createAdapterStatuses = (online: boolean): AdapterStatuses => ({
  auth: 'ready',
  tickets: online ? 'ready' : 'offline',
  tour: online ? 'ready' : 'offline',
  community: online ? 'ready' : 'offline',
  checkIn: online ? 'ready' : 'offline',
  notifications: online ? 'ready' : 'offline',
  content: online ? 'ready' : 'offline',
})

export const createInitialAppState = (online = true): AppState => ({
  schemaVersion: 2,
  bootstrapped: true,
  user: null,
  session: null,
  emailNextStepPending: false,
  selectedShowId: defaultShowId,
  shows: tourShows.map((show) => ({ ...show })),
  savedShowIds: [],
  tickets: [],
  itinerary: [],
  feedPosts: seedFeedPosts.map((post) => ({ ...post })),
  likedPostIds: [],
  savedPostIds: [],
  reportedPostIds: [],
  sharedPostIds: [],
  checkIns: [],
  passportStamps: [],
  notifications: seedNotifications.map((notification) => ({ ...notification })),
  content: seedContentItems.map((item) => ({ ...item })),
  preferences: { ...defaultPreferences },
  supportCases: [],
  adapterStatuses: createAdapterStatuses(online),
  online,
})
